<button mat-raised-button color="primary" (click)="exportArrayToExcel()" [disabled]="working">{{buttonTitle}}
    <mat-spinner *ngIf="working" diameter="20"></mat-spinner>
</button>